import styled from "styled-components";

const getButtonStyles = (type) => {
  switch (type) {
    case 'critical':
      return `
        background: linear-gradient(135deg, rgba(176, 42, 55, 0.1), rgba(154, 36, 47, 0.1));
        border: 1px solid rgba(176, 42, 55, 0.6);
        color: #FFFFFF;
        
        &:hover:not(:disabled) {
          background: linear-gradient(135deg, #b02a37, #9a242f);
        }
      `;
    case 'secondary':
      return `
        background: linear-gradient(135deg, #6c757d, #5a6268);
        border: 1px solid #6c757d;
        color: #FFFFFF;
        
        &:hover:not(:disabled) {
          background: linear-gradient(135deg, #5a6268, #495057);
        }
      `;
    case 'default':
    default:
      return `
        background: rgba(255,255,255,0.1);
        border: 1px solid rgba(255,255,255,0.2);
        color: #FFFFFF;
        
        &:hover:not(:disabled) {
            background: rgba(255,255,255,0.2);
        }
      `;
  }
};

const getWidthStyles = ($width, $fullWidth) => {
    const mode = $fullWidth ? 'fill' : ($width ?? 'fixed');

    if (mode === 'fill') {
        return `
            min-width: 0;
            width: 100%;
        `;
    }

    if (mode === 'hug') {
        return `
            min-width: 0;
            width: auto;
        `;
    }

    if (mode !== 'fixed') {
        const value = typeof mode === 'number' ? `${mode}px` : mode;
        return `
            min-width: 0;
            width: ${value};
        `;
    }

    return `
        width: 160px;
    `;
};

export const PrimaryBtnContainer = styled.button`
    box-sizing: border-box;
    border-radius: 4px;
    cursor: ${({ disabled }) => (disabled ? "default" : "pointer")};
    font-size: 12px;
    font-weight: 600;
    height: 40px;
    opacity: ${({ disabled }) => (disabled ? "0.4" : "1.0")};
    padding: 0px 16px;
    transition: ${({ disabled }) => (disabled ? "none" : "0.3s ease-in-out")};
    ${({ $type }) => getButtonStyles($type)}
    ${({ $width, $fullWidth }) => getWidthStyles($width, $fullWidth)}

    &:hover:not(:disabled) {
        transform: ${({ $type }) => ($type === 'critical' ? 'none' : 'scale(0.985)')};
    }
`